import { render, staticRenderFns } from "./copyAsTodoModal.vue?vue&type=template&id=3051ecaa&"
import script from "./copyAsTodoModal.vue?vue&type=script&lang=js&"
export * from "./copyAsTodoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports